import BasicModal from './BasicModal';
import {
  OFFLINE_MODE_INFO_BODY,
  OFFLINE_MODE_INFO_DISMISS,
  OFFLINE_MODE_INFO_TITLE,
  OFFLINE_MODE_KEEP_TAB_OPEN,
} from 'common/utils/offlineMode/constants';

type OfflineModeInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function OfflineModeInfoModal({ isOpen, onClose }: OfflineModeInfoModalProps) {
  return (
    <BasicModal
      ariaLabelBody={'Offline mode information'}
      ariaLabelCancelButton={'Cancel'}
      ariaLabelCloseButton={'Close offline mode information'}
      ariaLabelHeader={'Offline Mode'}
      ariaLabelSubmitButton={'Dismiss offline mode information'}
      hasCloseButton
      headerText={OFFLINE_MODE_INFO_TITLE}
      hideCancel
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onClose}
      submitText={OFFLINE_MODE_INFO_DISMISS}
    >
      <p>{OFFLINE_MODE_INFO_BODY}</p>
      <p>{OFFLINE_MODE_KEEP_TAB_OPEN}</p>
    </BasicModal>
  );
}
